<template>
  <div>
    <ul class="iv-declare-list">
      <li class="iv-p-b-24 iv-p-t-24" v-for="(item, i) in list" :key="i">
        <div class="iv-pull-left">
          <p class="iv-fs-16 iv-fc-65 iv-fw-b iv-m-t-12" >{{'2022年度BOE员工职业操守宣言签署'}}</p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-16">
            <span>年度: {{'2022'}}</span>
          </p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-12">
            <span class="iv-m-r-32">下发时间：{{timeFormat(item.startDate)}}</span>
            <span class="iv-m-r-24">签发时限时间：{{timeFormat(item.endDate)}}</span>
            <!-- <span class="iv-m-r-12">签发时间：{{timeFormat(item.startDate)}}</span> -->
            <span>状态：</span><span :style="{color: statusColor[item.isSign]}">{{status[item.isSign]}}</span>
          </p>
        </div>
        <div class="iv-pull-right iv-text-right">
          <span
            v-if="item.isSign == 'yes'"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'seeInfor')">查看签署内容</span>
          <span
            v-if="item.isSign != 'yes'"
            class="iv-declare-list-right-btn iv-pointer iv-fc-85 iv-text-center iv-m-l-16 iv-m-t-28" 
            @click="toDetailPage(item, 'edit')">签署职业操守宣言</span>
        </div>
      </li>
    </ul>
    <Page v-if="showPage" :total="total" :current="current" :pageSize="pageSize" class="iv-text-center iv-m-t-40" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
  </div>
</template>

<script>
import { timeFormat } from '@/utils'
import Page from '@/components/page'
import IconFont from '@/components/iconfont'

export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default: 'appraising'
    },
    showPage: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 1
    },
    current: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 5
    },
    map: {
      type: Object,
      default () {
        return {
          title: 'reviewInfoName',
          orgName: 'initiateOrgName',
          publishDate: 'publicTime',
          endDate: 'endDate'
        }
      }
    }
  },
  data () {
    return {
      dictMap: {
        'BOE41': {},
        'BOE411': {},
        'GG53': {}
      },
      status: {
        'no': '未签署',
        'yes': '已签署',
        'again': '重新签署'
      },
      statusColor: {
        'no': 'red',
        'yes': '#45BC7D',
        'again': 'orange'
      }
    }
  },
  created () {
    // this.getCodeTable('BOE41')
    // this.getCodeTable('BOE411')
    // this.getCodeTable('GG53')
  },
  methods: {
    timeFormat,
    computedName (item) {
      if (this.type === 'system') {
        return '下载附件'
      } else {
        return '查看详情'
      }
    },
    confirmStatusName (confirmStatus) {
      if (confirmStatus == '1_DJ_ZZ') {
        return '总支认定'
      } else if (confirmStatus == '1_DJ_DW') {
        return '党委认定'
      } else if (confirmStatus == '1_GH_XD') {
        return '现地认定'
      } else if (confirmStatus == '1_GH_JT') {
        return '集团认定'
      } else if (confirmStatus == '2_DJ_ZZ') {
        return '总支不认定'
      } else if (confirmStatus == '2_DJ_DW') {
        return '党委不认定'
      } else if (confirmStatus == '2_GH_XD') {
        return '现地不认定'
      } else if (confirmStatus == '2_GH_JT') {
        return '集团不认定'
      } else if (confirmStatus === '1') {
        return '已认定'
      } else if (confirmStatus == '2') {
        return '不认定'
      } else if (confirmStatus == '3') {
        return '待认定'
      }
    },
    helpStatusName (helpStatus) {
      if (helpStatus === 'draft' || helpStatus === 'disApprove') {
        return '未帮扶'
      } else if (helpStatus == 'pending') {
        return '审批中'
      } else if (helpStatus == 'approved') {
        return '已帮扶'
      }
    },
    changePage (page) {
      this.$emit('on-change', page)
    },
    changePageSize (page) {
      this.$emit('on-page-size-change', page)
    },
    //查看详情
    toDetailPage () {
      this.$emit('on-detail', ...arguments)
    },
    //数据字典
    getCodeTable (code) {
      this.$ajax({
        url: 'api-general/module/portal/user/outGetList',
        method: 'get',
        data: {
          dictCode: code,
          merge: false,
          bizLineCode: 'YWX01'
        }
      }).then(({data}) => {
        this.dictMap[code] = {}
        data.data.length &&  data.data.forEach(item => {
          if (!this.dictMap[code][item.value]) {
            this.dictMap[code][item.value] = item.title
          }
        })
      })
    }
  },
  components: {
    Page,
    IconFont
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/base/variable.scss';
.iv-declare-list {
  li {
    overflow: hidden;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
    .iv-declare-title-tag {
      padding: 3px 8px;
      border-radius: 4px;
      border: 1px solid #45BC7D;
      font-size: 14px;
      font-weight: normal;
    }
    .iv-declare-green {
      color: #45BC7D;
    }
    .iv-declare-yellow {
      color: #FFC757;
    }
    .iv-declare-list-right-btn {
      display: inline-block;
      width: 130px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      border-radius: 20px;
      padding: 0 5px;
      border: 1px solid rgba(0, 0, 0, 0.25);
      &:hover {
        color: $iv-main-hover-color !important;
        border-color: $iv-main-hover-color !important;
      }
    }
    .iv-declare-list-right-bottom {
      .iconfont {
        color: #45BC7D;
      }
      .iv-back-icon {
        color: $iv-main-border-color;
      }
      .iv-declare-list-res {
        position: relative;
        padding-left: 22px;
        em {
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -7px;
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border: 1px solid rgba(0, 0, 0, 0.25);
        }
        .iv-finish-em {
          border-color: #45BC7D;
          border-width: 4px;
        }
      }
    }
  }
}
</style>
